import { render } from "./ModalConfirmNegotiation.vue?vue&type=template&id=b406fe50&scoped=true&ts=true"
import script from "./ModalConfirmNegotiation.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmNegotiation.vue?vue&type=script&lang=ts"

import "./ModalConfirmNegotiation.vue?vue&type=style&index=0&id=b406fe50&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b406fe50"]])

export default __exports__